/**
 * Copyright (C) 2017-, Optio3, Inc. All Rights Reserved.
 *
 * Proprietary & Confidential Information.
 *
 * CoreStack External API
 * No description provided (generated by Swagger Codegen https://github.com/swagger-api/swagger-codegen)
 *
 * OpenAPI spec version: 1.0.0
 *
 *
 * NOTE: This class is auto generated by the swagger code generator program.
 * https://github.com/swagger-api/swagger-codegen.git
 * Do not edit the class manually.
 */

import * as models from './models';

export class AgentChatDelete {
    getFixupPrototypeFunction() { return AgentChatDelete.fixupPrototype; }

    static newInstance(model: Partial<AgentChatDelete>): AgentChatDelete {
        let obj = Object.assign(new AgentChatDelete(), model);
        AgentChatDelete.fixupPrototype(obj);
        return obj;
    }

    static deepClone(model: Partial<AgentChatDelete>): AgentChatDelete {
        if (!model) return null;
        return AgentChatDelete.newInstance(<AgentChatDelete> JSON.parse(JSON.stringify(model)));
    }

    static fixupPrototype(obj: AgentChatDelete) {
        if (!obj) return;

        models.AgentChatDelete.setPrototype(obj);

        obj.fixupFields();
    }

    protected static setPrototype(obj: AgentChatDelete): boolean {
        Object.setPrototypeOf(obj, AgentChatDelete.prototype);
        return false; // Not a polymorphic type, okay to overwrite the prototype.
    }

    fixupFields() {
    }

    /**
     * Indicates if the chat is deleted
     */
    status: boolean;

}
